import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Rodal from 'rodal'
import CancellationReasonOption from './components/CancellationReasonOption'
import * as subscriptionCancellationDuck from './subscriptionCancellationDuck'
import * as currentUserDuck from '../../../store/shared/currentUserDuck'
import selectors from '../../../store/shared/selectors'

const REASONS_FOR_CANCELLATION = [
  {
    displayName: "I didn't find it helpful",
    value: 'not_helpful',
  },
  {
    displayName: "The website wasn't working",
    value: 'not_working',
  },
  {
    displayName: "I've graduated",
    value: 'graduated',
  },
  {
    displayName: "I don't want to renew next year",
    value: "no_renew"
  },
  {
    displayName: "Just here for the free trail",
    value: "free_trial"
  }
]

export class SubscriptionCancellation extends Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    currentUserSuccess: PropTypes.func.isRequired,
    history: PropTypes.any.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isShowingModal: PropTypes.bool.isRequired,
    openModal: PropTypes.func.isRequired,
    performCancelSubscription: PropTypes.func.isRequired,
    selectOption: PropTypes.func.isRequired,
    selectedOption: PropTypes.any,
  }

  constructor(props) {
    super(props)

    this.state = {
      otherReason: '',
    }

    this.cancelSubscription = async (reason) => {
      try {
        const user = await this.props.performCancelSubscription({ reason_for_cancellation: reason })
        this.props.closeModal()
        this.props.currentUserSuccess(user)
        this.props.history.push('/app/recreate-subscription')
      } catch (error) {
        console.log(error)
      }
    }
  }

  render() {
    const {
      closeModal,
      isMobile,
      isShowingModal,
      selectOption,
      selectedOption,
    } = this.props

    const { otherReason } = this.state

    return (
      <Rodal
        visible={isShowingModal}
        measure="%"
        width={isMobile ? 90 : 50}
        height={isMobile ? 90 : 80}
        customMaskStyles={{ opacity: 0.5, backgroundColor: 'black' }}
        closeOnEsc
        onClose={closeModal}
        duration={100}
      >
        <div className="text-center" style={{ overflowY: 'auto', height: '100%' }}>
          <h4>We hate to see you go!</h4>
          <h5>Your feedback will help us serve others better</h5>
          <div
            className="list-group"
            style={{ marginTop: 50, marginBottom: 20 }}
          >
            {REASONS_FOR_CANCELLATION.map(reason => (
              <CancellationReasonOption
                key={reason.value}
                onClick={selectOption}
                option={reason}
                selected={selectedOption === reason.value}
              />
            ))}
          </div>
          <div className="form-group">
            <label>Other Reason</label>
            <textarea
              className="form-control"
              onChange={e => { this.setState({ otherReason: e.target.value }) }}
              value={otherReason}
            />
          </div>
          <h6 className="small text-danger" style={{ fontWeight: 'bold' }}>
            Are you sure? You won't be able to access any of our great features
            once you cancel.
          </h6>
          <button
            id="cancelSubscriptionBtn"
            disabled={!selectedOption && otherReason.length === 0}
            className="btn btn-danger btn-small"
            style={{ marginTop: 10 }}
            onClick={() => this.cancelSubscription(selectedOption || otherReason)}
          >
            Cancel My Subscription
          </button>
        </div>
      </Rodal>
    )
  }
}

const mapStateToProps = state => ({
  isCancelledSuccessfully: subscriptionCancellationDuck.getIsCancelledSuccessfully(
    state,
  ),
  isRequestingCancellation: subscriptionCancellationDuck.isRequestingCancellation(
    state,
  ),
  isShowingModal: subscriptionCancellationDuck.getIsShowingModal(state),
  isMobile: selectors.isLessThanMedium(state),
  selectedOption: subscriptionCancellationDuck.getSelectedOption(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      closeModal: subscriptionCancellationDuck.closeModal,
      currentUserSuccess: currentUserDuck.currentUserSuccess,
      openModal: subscriptionCancellationDuck.openModal,
      performCancelSubscription:
        subscriptionCancellationDuck.performCancelSubscription,
      selectOption: subscriptionCancellationDuck.selectOption,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter(SubscriptionCancellation),
)



// WEBPACK FOOTER //
// ./src/components/ui/SubscriptionCancellation/SubscriptionCancellation.js